import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";

import './leaders.css'

const Purpose = () => {
    return (
        <Box className="App-header">
            <Box className='pastor-container'>
            <Stack direction='row' spacing={8}>
                <Stack className='pastor-column' spacing={2}>
                    <Typography level='h1'>
                        Purpose
                    </Typography>
                    <Typography level='h4'>
                        Mission
                    </Typography>
                    <Typography level='body-md'>
                        Our mission is to encourage people to Draw Closer in their relationship with God, to Grow Stronger in their relationship with each other and to Live Louder in their relationship with the world.
                    </Typography>
                    <Typography level='h4'>
                        Guiding Principles
                    </Typography>
                    <Typography level='body-md'>
                        Everything we do as a community of faith flows from these three relationships. We believe that at His core God is a relational Being, evidenced by the Trinity. The Father, Son and Holy Spirit have always enjoyed community together and have asked us to join in that relationship.  We desire to bring as many as we can into this divine dance by following these principles.
                    </Typography>
                    <List component="ol" marker="decimal">
                        <ListItem>Experiential Worship- Worship is at the heart of who we are. We place value on encountering God through songs not only sung about God, but to Him. As we draw closer in worship it creates an atmosphere that invites His presence.</ListItem>
                        <ListItem>Transformational Discipleship- Transformation comes through relationships that are intentional and intimate. We grow stronger when we form relationships that change the way we live and the way we love others.</ListItem>
                        <ListItem>Simple Service- We encourage everyone to play because everyone is gifted by God with a unique personality and a unique set of talents. It takes everyone to become the community God has called us to be.</ListItem>
                        <ListItem>Impacting Evangelism- We believe it is our responsibility to be Jesus to our community and demonstrate the reality of His power and presence. We do this by being Jesus to others as we just live our lives. We also do this by special events that demonstrate the power of Jesus in community.</ListItem>
                    </List>
                    <Typography level='h4'>
                        Over environment is an expression of our values
                    </Typography>
                    <List marker="disc">
                        <ListItem>We believe that it is our responsibility to provide an accepting and welcoming atmosphere so that our mission can be lived out.</ListItem>
                        <ListItem>We strive to be real.  We are not perfect and don’t pretend to be. We are loved by Jesus as we are and we believe we should do the same. It is Jesus who will prompt change when needed. We get to demonstrate we are his disciples by our love.</ListItem>
                        <ListItem>We are not formal, but casual in style.  We want you to feel comfortable and relaxed so come as you are.</ListItem>
                        <ListItem>We embrace diversity. We strive to be a church that looks like heaven with a diversity of cultures unified by belief in Jesus.</ListItem>
                        <ListItem>We do hold to the truths of Scripture as expressed in orthodox Christianity but we also believe NHV should be a safe place for people to ask difficult questions and not be rejected as they wrestle for answers.</ListItem>
                        <ListItem>We believe that our kids are our future and that they should be a high priority. We will develop ministries to help them embrace Jesus and the mission of NHV.</ListItem>
                    </List>
                </Stack>
                <Box className='pastor-column'>
                    <img className='pastor-image' src='https://nhvineyard.com/wp-content/uploads/2018/02/freely-56004.jpg'/>
                </Box>
            </Stack>
        </Box>
        </Box>
        
    );
};

export default Purpose;